export const apiAuthorizationConfig = {
    endpoint: '/',

    applicationName: 'EndUserPortal',
};